import { http } from "../api";
const easyUnpack = ({ data }) => data;
export const LassieOrganizationApi = {
    list_organizations: {
        f: function list_organizations() {
            let url = '/lassie/organization/';
            return http.get(url, { params: {} }).then(easyUnpack)
        }
    },
    list_organization_users: {
        f: function list_organization_users(organization_id) {
            let url = '/lassie/organization/$organization_id/users';
            let parameterNames = ["$organization_id"];
            [organization_id].forEach((parameterValue, index) => {
                url = url.replace(parameterNames[index], parameterValue)
            })
            return http.get(url, { params: {} })
                .then(easyUnpack)
        }
    },
    list_organization_windfarms: {
        f: function list_organization_windfarms(organization_id) {
            let url = '/lassie/organization/$organization_id/windfarms';
            let parameterNames = ["$organization_id"];
            [organization_id].forEach((parameterValue, index) => {
                url = url.replace(parameterNames[index], parameterValue)
            })
            return http.get(url, { params: {} })
                .then(easyUnpack)
        }
    },
    list_inspection_templates: {
        f: function list_inspection_templates(organization_id) {
            let url = '/lassie/organization/$organization_id/inspection-templates';
            let parameterNames = ["$organization_id"];
            [organization_id].forEach((parameterValue, index) => {
                url = url.replace(parameterNames[index], parameterValue)
            })
            return http.get(url, { params: {} }).then(easyUnpack)
        }
    },
    create_inspection_template: {
        f: function create_inspection_template(organization_id, title, comment,
            { due_in_hours = null, overdue_remind_in_days = null, inspection_type = null, inspection_method = null }) {
            let url = '/lassie/organization/$organization_id/inspection-templates';
            let parameterNames = ["$organization_id"];
            [organization_id].forEach((parameterValue, index) => {
                url = url.replace(parameterNames[index], parameterValue)
            })
            return http.post(url, { title, comment, due_in_hours, overdue_remind_in_days, inspection_type, inspection_method }).then(easyUnpack)
        }
    },
    delete_inspection_template: {
        f: function delete_inspection_template(template_id) {
            let url = '/lassie/organization/inspection-templates/$template_id';
            let parameterNames = ["$template_id"];
            [template_id].forEach((parameterValue, index) => {
                url = url.replace(parameterNames[index], parameterValue)
            })
            return http.delete(url, { data: {} }).then(easyUnpack)
        }
    },
    update_inspection_template: {
        f: function update_inspection_template(template_id, title, comment,
            { due_in_hours = null, overdue_remind_in_days = null, inspection_type = null, inspection_method = null }) {
            let url = '/lassie/organization/inspection-templates/$template_id';
            let parameterNames = ["$template_id"];
            [template_id].forEach((parameterValue, index) => {
                url = url.replace(parameterNames[index], parameterValue)
            })
            return http.patch(url, { title, comment, due_in_hours, overdue_remind_in_days, inspection_type, inspection_method }).then(easyUnpack)
        }
    },
};
